import type { Plan } from '../types';

// Origine de la ligne d'abonnement. Discriminant : revenuecat_id, renseigné pour une souscription
// réelle, NULL pour un droit accordé côté base (bêta « pro pour tous », cf. migration 0024).
// On ne remonte QUE cette distinction, jamais l'identifiant lui-même.
export type SubscriptionSource = 'revenuecat' | 'granted';

// État d'abonnement lu depuis la table `subscriptions` (source unique de vérité).
export interface SubscriptionStatus {
  plan: Plan;
  status: string;
  currentPeriodEnd: string | null; // ISO ; NULL tant qu'aucun paiement réel n'est câblé
  source: SubscriptionSource;
}

const PAID_PLANS: Plan[] = ['plus', 'pro', 'school'];

// Jours entiers restants avant `dateISO` (arrondi au jour supérieur). Négatif si déjà passé.
export function daysUntil(dateISO: string, now: Date = new Date()): number {
  const diffMs = new Date(dateISO).getTime() - now.getTime();
  return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
}

// Renvoie le nombre de jours avant échéance SI un rappel doit s'afficher, sinon null.
// Conditions : plan payant + abonnement actif/trialing + date d'échéance connue et à venir.
// Tant que `currentPeriodEnd` est NULL (aucun paiement câblé), renvoie toujours null → rappel dormant.
export function expiryReminderDays(sub: SubscriptionStatus | null, now: Date = new Date()): number | null {
  if (!sub) return null;
  if (!PAID_PLANS.includes(sub.plan)) return null;
  if (sub.status !== 'active' && sub.status !== 'trialing') return null;
  if (!sub.currentPeriodEnd) return null;
  const days = daysUntil(sub.currentPeriodEnd, now);
  return days < 0 ? null : days;
}
